module.exports = __webpack_public_path__ + "img/甘肃交通广播_01.ede1c646.jpg";